import { RegionShared } from "@1games-ru/region-shared";
import { useQuery } from "@tanstack/react-query";
import Loader from "@/shared/ui/Loader";
import VehicleDetails from "@/shared/widgets/VehicleDetails";
import { QueryKey } from "@/domains/transportWarehouse/constants/queryKey";
import { fetchVehicleDetails } from "@/domains/transportWarehouse/helpers/fetchVehicleDetails";

type Props = typeof RegionShared.Backend.Requests.GarageGetVehicleInfoRequest;

export default function TransportWarehouseVehicleDetailsContainer({ vehicleId, garageId }: Props) {
  const { data, isLoading, isError } = useQuery({
    queryKey: [`${QueryKey.VehiclesDetails}-${garageId}-${vehicleId}`],
    queryFn: () => fetchVehicleDetails({ vehicleId, garageId }),
    enabled: !!vehicleId,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return "error";
  }

  return <VehicleDetails vehicle={data} isDetaching={false} />;
}
